import { render, staticRenderFns } from "./Ekomi.vue?vue&type=template&id=777dcf9b&scoped=true&"
import script from "./Ekomi.vue?vue&type=script&lang=js&"
export * from "./Ekomi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "777dcf9b",
  null
  
)

export default component.exports